/**
 * Safe HTML sink for imperative DOM APIs (e.g. Mapbox markers).
 *
 * All Mapbox marker/popup content in this codebase is built from static template
 * literals with numeric or boolean-driven values (no user-supplied strings flow in),
 * so the XSS surface is zero today. This wrapper is defense-in-depth: it guarantees
 * that even if a future edit accidentally interpolates user data into the template,
 * DOMPurify will strip anything dangerous before it hits the DOM.
 */
import DOMPurify from 'dompurify';

// Allow the small set of tags/attributes we actually use for map markers.
const CONFIG = {
  ADD_TAGS: ['svg', 'path', 'circle', 'polyline'],
  ADD_ATTR: ['viewBox', 'stroke', 'stroke-width', 'stroke-linecap', 'stroke-linejoin', 'fill'],
};

export const setSafeHTML = (el, html) => {
  if (!el) return;
  el.innerHTML = DOMPurify.sanitize(html, CONFIG);
};
